import { inject, Injectable } from '@angular/core';

import { VehicleSearchQuery } from '../../model/customer-search-query.model';
import { FoundCustomer } from '../../model/found-customer.model';
import { EsoCrmClient } from './eso-crm.client';
import { EsoCrmFoundCustomerViewModelMapper } from './mapper/found-customer-model.mapper';

@Injectable({
  providedIn: 'root',
})
export class EsoCrmService {
  private readonly client = inject(EsoCrmClient);
  private readonly foundCustomerMapper = inject(EsoCrmFoundCustomerViewModelMapper);

  async searchCustomersViaVehicle(query: VehicleSearchQuery): Promise<FoundCustomer[]> {
    const vehiclesResonse = await this.client.searchCustomersViaVehicle(query);
    return this.foundCustomerMapper.mapToFoundCustomers(vehiclesResonse);
  }
}
